import * as React from 'react';
import { render } from 'react-dom';
import Axios from 'axios';
import Search from './components/Search';
import SearchItem from './components/SearchItem';
import './scss/style.scss';
import Filter from './components/Filter';

Axios.defaults.baseURL = process.env.API_URL;

interface State {
  didSearch: boolean;
  items: any[];
  isSearching: boolean;
  sources: string[];
  filteredSources: string[];
}

export default class App extends React.Component<{}, State> {
  constructor(props) {
    super(props);
    this.state = {
      didSearch: false,
      items: [],
      isSearching: false,
      sources: [],
      filteredSources: [],
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchProvider = this.handleSearchProvider.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
  }

  async handleSearch(search: string) {
    if (this.state.isSearching || !search.trim() || search.trim().length < 3) {
      return;
    }
    this.setState({
      didSearch: true,
      isSearching: true,
      items: [],
      sources: [],
      filteredSources: [],
    });
    const providers = ['gear4music', 'andertons', 'guitarguitar', 'pmt', 'thomann'];
    await Promise.all(
      providers.map(async (provider) =>
        this.handleSearchProvider(provider, search.trim()),
      ),
    );
    this.setState({ isSearching: false });
  }

  async handleSearchProvider(provider: string, search: string) {
    const response = await Axios.post(`/search/${provider}/${search}`);
    const items = this.state.items;
    const newItems = response.data;
    if (newItems.length > 0) {
      const sources = this.state.sources;
      const filteredSources = this.state.filteredSources;
      sources.push(newItems[0].source);
      filteredSources.push(newItems[0].source);
      this.setState({
        sources,
        filteredSources,
        items: items
          .concat(newItems)
          .sort((a, b) => Math.sign(a.price - b.price)),
      });
    }
  }

  async handleFilter(source: string) {
    const filteredSources = this.state.filteredSources;
    const index = filteredSources.indexOf(source);
    if (index === -1) {
      filteredSources.push(source);
    } else {
      filteredSources.splice(index, 1);
    }
    this.setState({ filteredSources });
  }

  render() {
    const items = this.state.items.filter(
      (item) => this.state.filteredSources.indexOf(item.source) !== -1,
    );
    return (
      <>
        <section className={`hero is-dark ${this.state.didSearch ? '' : 'is-fullheight'}`}>
          <div className="hero-body">
            <div className="container">
              <div className="columns is-centered">
                <div className="column is-8">
                  <h1 className="title">The Analogue Catalogue</h1>
                  <Search
                    handleSubmit={this.handleSearch}
                    isSearching={this.state.isSearching}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {this.state.didSearch &&
          <section className="section">
            <div className="container">
              <div className="columns is-centered">
                <div className="column is-8">
                  {this.state.items.length > 0 && (
                    <>
                    <Filter
                      sources={this.state.sources}
                      filteredSources={this.state.filteredSources}
                      handleFilter={this.handleFilter}
                    />
                      <div className="content">
                        Showing <strong>{items.length}</strong> item{items.length !==
                          1 && 's'}{' '}
                        across {this.state.filteredSources.length} source{this
                          .state.filteredSources.length !== 1 && 's'}:
                      </div>
                      {this.state.isSearching && 
                        <div className="content is-flex is-flex-direction-column is-align-items-center">
                          <span className="loader"></span>
                        </div>
                      }
                      {items.length > 0 && (
                        <div className="box">
                          {items.map((item, index) => (
                            <SearchItem key={index} item={item} />
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </section>
        }
      </>
    );
  }
}

render(<App />, document.getElementById('app'));
